import React, { Fragment } from "react";
import { isVariantAvailableForSale } from '../../../utils/checkVariantAvailability';

const VariantButton = ({
  title = "",
  currentVariant = "",
  optionKey = "",
  variantKey = "",
  changeVariant,
  options = [],
  variants = [],
  selectedOptions = [],
  hideLabel = false,
}) => {
  return (
      <Fragment>
        {currentVariant && (
            <p className="mt-[6px] mb-[10px]">{hideLabel ? "" : title}</p>
        )}
        <div className="flex gap-[5px] flex-wrap">
          {options?.map((option, index) => {
            const isAvailable = isVariantAvailableForSale(variantKey, selectedOptions, variants, optionKey, option);
            return (
              <button
                  key={index}
                  className={`relative overflow-hidden variant_button pp-no-hide ${
                      !isAvailable &&
                      option === currentVariant
                          ? "opacity-50 hover:bg-none"
                          : !isAvailable &&
                          "opacity-50 hover:bg-none after:absolute after:top-[15px] after:-left-[3px] after:w-full after:h-[1px] after:-rotate-45 after:bg-current"
                  } ${
                      option === currentVariant
                          ? "variant_button_selected"
                          : "variant_button_notselected"
                  }`}
                  onClick={() => changeVariant(variantKey, option)}
              >
                {option}
              </button>
            )}
          )}
        </div>
      </Fragment>
  );
};

export default VariantButton;
